import React, { Component } from 'react';
import { connect } from 'react-redux';

import Assistenza from '../../Icons/Assistenza';
import PagamentoSicuro from '../../Icons/PagamentoSicuro';

import IndexLink from '../../../shared/IndexLink/IndexLink';

import './CheckoutHeader.scss';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';

class CheckoutHeader extends Component {
  render() {
    const { phone, logoImage, primaryColor } = this.props;

    return (
      <div className="checkout-header">
        <div className="container container-wide">
          <div className="d-flex flex-row align-items-center justify-content-between">
            <div className="left-header">
              <IndexLink
                to="/"
                className="logo"
                activeClassName="active"
                aria-label="Vai alla homepage"
              >
                <ImageDispatcher alt="Logo" src={logoImage} />
              </IndexLink>
            </div>
            <div className="center-header">
              <span style={{ color: primaryColor }}>
                <Assistenza />
              </span>
              Assistenza Clienti&nbsp;
              <a href={'tel:' + phone} style={{ color: primaryColor }}>
                {phone}
              </a>
            </div>
            <div className="right-header">
              <span style={{ color: primaryColor }}>
                <PagamentoSicuro />
              </span>
              Pagamenti sicuri
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    phone: state.store.data.datiFarmacia.phone,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
  };
}

export default connect(mapStateToProps)(CheckoutHeader);
